import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, first } from 'rxjs/operators';
import { CustomerModel } from 'src/app/models/customer-model';
import { toBoolean } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { GameHub } from 'src/app/services/gameHub/game-hub';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { TimeService } from 'src/app/services/time-service/time.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { Navigator } from '../menu/navigator';
import { Platform } from '@ionic/angular';
import { SafeArea } from "capacitor-plugin-safe-area";

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
})

export class GameComponent implements OnInit, OnDestroy, AfterViewInit {
  public showRecentPlayedGames: boolean;
  public game_height: object = {};
  public show: boolean = true;
  public timeOnlineEnabled: boolean;
  public showTimeOnline: boolean;
  public isMobile: boolean;
  public isMobileOrMobileWeb: boolean;
  public isMobileWeb: boolean;
  public isCordova: boolean;
  public isCapacitor: boolean;
  public isIOSApp: boolean;
  public windowResizeSubscription: Subscription;
  public instanceId: string;
  public showPreloader: boolean = true;
  public notifyCustomerRotate: boolean = false;
  public onlineTimeInterval: ReturnType<typeof setInterval>;
  public timeOnline: string;
  public gameURL: SafeResourceUrl;
  public showMyGamesPane: boolean = true;
  public customer: CustomerModel;
  public isAuthenticated: boolean;
  public isDemoGame: boolean = false;
  public backButtonSubscribtion: Subscription;
  public dataToDisplay: string;
  public netPositionDelay: any;
  public netWinOperator: string = "+";
  public netWinAmount: string = '0.00';
  public isClosed: boolean = false;
  public showAPD: boolean = false;

  constructor(
    private gameHubService: GameHub,
    private eventsService: EventsService,
    private sanitizer: DomSanitizer,
    private userSessionService: UserSessionService,
    public navigator: Navigator,
    private config: ConfigService,
    public webservices: WebservicesService,
    private gameHubControllerService: GameHubControllerService,
    private timeService: TimeService,
    public platform: Platform,
    private zone: NgZone,
  ) {
    this.userSessionService
      .getCustomerSubscription()
      .then((customerSubject) =>
        customerSubject.subscribe((customer) => (this.customer = customer))
      );
    this.userSessionService
      .isAuthenticated()
      .then((isAuthenticated) => (this.isAuthenticated = isAuthenticated));

    this.backButtonSubscribtion = platform.backButton.subscribeWithPriority(101, () => {
      this.gameHubControllerService.terminateGame();
    });

    this.netPositionDelay = this.config.getConfig().FEATURE_NET_POSITION_DELAY || '0';
    this.eventsService.subscribe('event:GameStats:Response', (data) => {
      this.dataToDisplay = data;
      let timeout = 0;
      if (this.netPositionDelay) {
        if (this.netPositionDelay == 0) {
          timeout = 0;
        } else {
          timeout = this.netPositionDelay * 1000;
        }
      }
      //configurable delay to display Net Position on UI  
      setTimeout(() => {
        if (this.dataToDisplay.startsWith('-')) {
          this.netWinOperator = "-";
          this.netWinAmount = this.dataToDisplay.substring(1);
        } else {
          this.netWinOperator = "+";
          this.netWinAmount = this.dataToDisplay;
        }
      }, timeout);
    });

  }

  ngOnInit() {
    this.eventsService.subscribe("event:notifyCustomerRotate:end",()=>{
      this.notifyCustomerRotate = false;
    })
    this.notifyCustomerRotate = this.gameHubControllerService.shouldNotifyCustomerRotate;
    this.showRecentPlayedGames = toBoolean(this.config.getConfig().FEATURE_SHOW_RECENT_PLAYED_ON_GAME_PAGE) ?? false;
    this.showAPD =  (this.config.getConfig().SHOW_PIGGY_BANK_LOBBY === "1" ? true : false) || this.config.getConfig().SHOW_LB_LOBBY === "1" ? true : false;
    if (this.isMobileOrMobileWeb) {
      this.showTimeOnline = this.config.getConfig().FEATURE_SHOW_TIME_ONLINE ?? 0;
    }

    this.eventsService.publish("event:bottomfooter:hide")


    // this.setPlatforms is called from games component
    this.onWindowResize();

    setTimeout(() => {
      this.showPreloader = false;
    }, 1000);

    document.addEventListener('fullscreenchange', () => {
      if (!document.fullscreenElement) {
        this.clearMobileLook();
      }
    });

    if (this.showTimeOnline) {
      if (this.onlineTimeInterval) {
        clearInterval(this.onlineTimeInterval);
        this.onlineTimeInterval = null;
      }

      this.timeOnline = this.timeService.getOnlineTime() || '';
      this.onlineTimeInterval = setInterval(() => {
        this.timeOnline = this.timeService.getOnlineTime() || '';
      }, 30000);
    }

    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 500);

  }

  //After Game Componenet is created and view becomes visible set the game Height
  ngAfterViewInit() {
    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.onlineTimeInterval);
    this.onlineTimeInterval = null;
    if(this.platform.is('ios')){
      this.resetIOSMargins();
    }

    if (this.windowResizeSubscription) {
      this.windowResizeSubscription.unsubscribe();
    }
    if (this.backButtonSubscribtion) {
      this.backButtonSubscribtion.unsubscribe();
    }

    //this.gameHubControllerService.terminateGame();
  }

  ionViewDidEnter() {
    this.onWindowResize();
    setTimeout(() => {
      this.setPlaceholderHeight();
    }, 0)
  }

  ionViewWillLeave() {
    if (this.isMobile) {
      this.clearMobileLook();
    }

    if (!!this.windowResizeSubscription)
      this.windowResizeSubscription.unsubscribe();

    this.gameHubService.muteAllGames();
    this.gameHubService.unfocusInstance(this.instanceId);
  }

  private onWindowResize = () => {
    if (!!this.windowResizeSubscription)
      this.windowResizeSubscription.unsubscribe();

    this.windowResizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(600))
      .subscribe(
        (event) => {
          // console.log('resize', Date.now());
          this.setPlaceholderHeight();
          // setTimeout(() => this.gameHubControllerService.iframePostMessage('IAB_WINDOW_RESIZE'), 1000);
        }
      );
  };

  public setPlaceholderHeight() {
    if (this.isMobileOrMobileWeb) {
      this.setMobileLook();
      if(this.platform.is('ios')){
        this.applyHorizontalSafeArea();
      }
    } else {
      const headerElement: any = document.querySelector("app-site-header ion-header");
      const headerHeight: any = !!headerElement ? headerElement.offsetHeight : 0;

      const isIpadPortrait = this.platform.is('ipad');
      const padBottom = isIpadPortrait ? 52 : 0;
      let height = window.innerHeight - headerHeight - padBottom;
      this.game_height = { height: `${height}px`, marginTop: `${headerHeight}px` };

      setTimeout(() => {
        console.log('setDesktopLook', window.innerHeight);
        this.zone.run(() => {
          let height = window.innerHeight - headerHeight - padBottom;
          this.game_height = { height: `${height}px`, marginTop: `${headerHeight}px` };
        });
      }, 500);
    }

  }

  changeBackground() {
    if (this.platform.is('ios')) {
      if (document && document.body) document.body.style.backgroundColor = 'black'
    }
  }

  showGame(show: boolean) {
    this.show = show;
  }

  setInstanceId(instanceId) {
    this.instanceId = instanceId;
  }

  setGameUrl(url, session_token, isDemo) {

    const deviceType = this.gameHubControllerService.getDeviceType();
    const obj: any = {
      session_token: session_token
    }
    this.webservices.getApiNoRedirect(url, deviceType, obj).pipe(first()).subscribe(
      resp => {
        if (!!resp.result && resp.payload) {
          let url = '';
          if ('href' in resp.payload) url = resp.payload.href;
          if ('src' in resp.payload) url = resp.payload.src;
          this.gameURL = this.sanitizer.bypassSecurityTrustResourceUrl(url + '&windowID=' + this.instanceId);
        }
      }
    )
  }

  drawerClicked(event) {
    console.log("drawer click event", event);
  }

  public setPlatforms(platforms) {
    this.isMobile = platforms.isMobile;
    this.isMobileOrMobileWeb = platforms.isMobileOrMobileWeb;
    this.isMobileWeb = platforms.isMobileWeb;
    this.isCordova = platforms.isCordova;
    this.isCapacitor = platforms.isCapacitor;
    this.isIOSApp = platforms.isIOSApp;
  }

  private clearMobileLook() {
    const scrollContent = document.querySelector('app-game');
    const topHeaderEl: any = document.querySelector('ion-toolbar');
    const keywordsComponent = document.getElementsByTagName('app-site-header')[0];

    if (!!keywordsComponent)
      keywordsComponent.setAttribute('style', 'display:block');


    if (!!scrollContent) scrollContent.setAttribute('style', 'overflow-y: auto;');
    if (!!topHeaderEl) topHeaderEl.setAttribute('style', 'display:block');
  }

  public setMobileLook() {

    const tabbar = document.querySelector('.tabbar');
    const scrollContent = document.querySelector('games-home .scroll-content');

    if (!!tabbar)
      tabbar.setAttribute('style', 'display:none');

    if (!!scrollContent) {
      scrollContent.setAttribute('style', 'overflow-y: hidden;');
      scrollContent.setAttribute('style', 'margin-top: 0!important;');
    }

    const headerElement: any = document.querySelector("app-site-header ion-header");
    const headerHeight: any = !!headerElement ? headerElement.offsetHeight : 0;
    // console.log(`headerElement:`, headerElement)

    const IOSMobile = (this.platform.is('capacitor') && this.platform.is('ios'));
    const isIOS =  this.platform.is('ios')
    const isIOSPortrait = IOSMobile && this.platform.isPortrait();
    const isIOSLandScape = isIOS && this.platform.isLandscape();
    const padTop = 0;
    const padBottom = isIOSPortrait ? 52 : isIOSLandScape ? 15 : 5;
    const gameTop = headerHeight - padTop;
    const gameHeight = window.innerHeight - gameTop - padBottom;
    this.game_height = { height: `${gameHeight}px`, marginTop: `${gameTop}px` };

    console.log(`setMobileLook1: window.innerHeight: ${window.innerHeight}, gameHeight: ${gameHeight}, gameTop: ${gameTop}`);

    setTimeout(() => {
      this.zone.run(() => {
        let gameHeight = window.innerHeight - gameTop - padBottom;
        this.game_height = { height: `${gameHeight}px`, marginTop: `${gameTop}px` };
        console.log(`setMobileLook2: window.innerHeight: ${window.innerHeight}, gameHeight: ${gameHeight}, gameTop: ${gameTop}`);
      });
    }, 500);

    window.scrollTo(0, 0);
  }

  async applyHorizontalSafeArea() {
    if (this.platform.is("capacitor")) {
    const insets = await SafeArea.getSafeAreaInsets();
    document.documentElement.style.marginLeft = `${insets.insets.left}px`;
    document.documentElement.style.marginRight = `${insets.insets.right}px`;
    document.body.style.width = `calc(100% - ${insets.insets.left + insets.insets.left}px)`;
    } else {
      document.body.style.backgroundColor = "black";
      document.body.style.marginLeft = `env(safe-area-inset-left)`;
      document.body.style.marginRight = `env(safe-area-inset-right)`;
      document.body.style.width = `calc(100% - env(safe-area-inset-left) - env(safe-area-inset-right))`;
    }
  }

  resetIOSMargins(){
    if(this.platform.is("capacitor")){
      document.documentElement.style.marginLeft = `0px`;
      document.documentElement.style.marginRight = `0px`;
      document.body.style.width = `100%`
    } else {
      document.body.style.marginLeft = `0px`;
      document.body.style.marginRight = `0px`;
      document.body.style.width = `100%`;
    }
  }
}
